// Owner-private saved views (tasks-clickup-overhaul P1.7) — thin API wrappers
// over /api/me/views. The `spec` blob is the persisted ViewState.

import { api } from "../lib/api";
import type { ViewState } from "../lib/viewState";

export interface PersonalView {
  id: number;
  scope_key: string;
  name: string;
  spec: ViewState;
  created_at: string;
  updated_at: string;
}

export function listPersonalViews(scopeKey: string): Promise<PersonalView[]> {
  return api<PersonalView[]>(`/api/me/views?scope_key=${encodeURIComponent(scopeKey)}`);
}

export function createPersonalView(scopeKey: string, name: string, spec: ViewState): Promise<PersonalView> {
  return api<PersonalView>("/api/me/views", {
    method: "POST",
    body: { scope_key: scopeKey, name, spec },
  });
}

export function updatePersonalView(
  id: number,
  patch: { name?: string; spec?: ViewState }
): Promise<PersonalView> {
  return api<PersonalView>(`/api/me/views/${id}`, { method: "PATCH", body: patch });
}

export function deletePersonalView(id: number): Promise<void> {
  return api(`/api/me/views/${id}`, { method: "DELETE" }) as unknown as Promise<void>;
}
